<template>
  <div class="phone-settings">
    <!-- <div class ="setting-title">
      設定
    </div> -->
    <el-row class="vertical-space">
      <el-col :span="24" class="setting-title"> ノイズキャンセリング </el-col>
      <el-col class="setting-desc">
        ノイズキャンセルの強さを設定します。<br />（0〜100）
      </el-col>
      <el-col :span="24">
        <el-col class="vertical-space"> 自分の音</el-col>
        <el-col :span="19">
          <el-slider v-model="noiseCancelSpeech"></el-slider>
        </el-col>
        <el-col :span="5">
          <el-input
            class="setting-voice"
            v-model="noiseCancelSpeech"
            placeholder=""
          ></el-input>
        </el-col>
      </el-col>
    </el-row>

    <el-row class="vertical-space">
      <el-col :span="24">
        <el-col> 周囲の音</el-col>
        <el-col :span="19">
          <el-slider v-model="noiseCancelBk"></el-slider>
        </el-col>
        <el-col :span="5">
          <el-input
            class="setting-voice"
            v-model="noiseCancelBk"
            placeholder=""
          ></el-input>
        </el-col>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Settings",
	props: {
	},
    data() {
		return {
      // DashboardではsysInitがないため、デフォルト値を使用
      noiseCancelSpeech: 50,
      noiseCancelBk: 50,
    };
	},

}
</script>

<style lang="scss" scoped>
.phone-settings{
  padding:12px 12px;
  line-height: 24px;
  font-size: 14px;
  color: #000;
  .setting-title{
    font-weight: 600;
  }
  ::v-deep .el-slider__bar {
    height: 3px;
    background: #063253 ;
  }
  ::v-deep .el-slider__runway {
    height: 3px ;
    width: 200px;
    background: #063253;
    // margin: 10px 0px 10px 10px;
  }

}

</style>
